import { computed } from '@angular/core';
import { withDevtools } from '@angular-architects/ngrx-toolkit';

import {
  patchState,
  signalStore,
  withComputed,
  withMethods,
  withState,
} from '@ngrx/signals';

const initialState: {
  zoomLevel: number;
  showSelectionControl: boolean;
  selectedTerritories: string[];
} = {
  selectedTerritories: [],
  showSelectionControl: false,
  zoomLevel: 0,
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const MapStore = signalStore(
  { providedIn: 'root' },
  withDevtools('mapStore'),
  withState(initialState),

  withComputed(({ selectedTerritories }) => ({
    selectedTerritoriesIds: computed(() => new Set(selectedTerritories())),
  })),
  withMethods(({ ...store }) => ({
    setZoom: (zoom: number | undefined): void => {
      patchState(store, () => ({ zoomLevel: zoom }));
    },

    toggleSelectedTerritory: (territoryId: string) => {
      patchState(store, (state) => ({
        selectedTerritories: store.selectedTerritoriesIds().has(territoryId)
          ? state.selectedTerritories.filter((id) => id !== territoryId)
          : [...state.selectedTerritories, territoryId],
      }));
    },

    toggleSelectionControl: (showSelection: boolean) => {
      patchState(store, () => ({ showSelectionControl: showSelection }));
    },

    updateSelectedTerritories: (selectedTerritories: string[]) => {
      patchState(store, () => ({ selectedTerritories }));
    },
  })),
);
